import { 
  Component, 
  ComponentRef, 
  Inject, 
  OnDestroy, 
  OnInit, 
  TemplateRef, 
  ViewChild, 
  ViewContainerRef,
  AfterViewInit,
  EmbeddedViewRef,
} from '@angular/core';

import { 
  Router,
  ActivatedRoute, 
  ParamMap 
} from '@angular/router';

import { Location } from '@angular/common';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {Title} from "@angular/platform-browser";

import { 
  MsalInterceptorConfiguration, 
  MsalService, 
  MSAL_INTERCEPTOR_CONFIG 
} from '@azure/msal-angular';


import { 
  AccountInfo, 
  EndSessionRequest 
} from '@azure/msal-browser';

import { LoadingBarService } from '@ngx-loading-bar/core';

import { isNil, isObject } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexErrorService } from './error/datex-error-service';
import { protectedResources } from './auth-config';

import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';
import { WavelengthUiModule, WavelengthShellService, IMenubarItem, MenuItemModel } from 'wavelength-ui';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { app_ShellService } from './app.shell.service';
import { app_OperationService } from './app.operation.service';
import { app_DatasourceService } from './app.datasource.index';
import { app_FlowService } from './app.flow.index';
import { app_ReportService } from './app.report.index';
import { app_LocalizationService } from './app.localization.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './app.frontend.types'
import { $frontendTypes as $types} from './app.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


enum EmbedScriptType {
  Inline,
  External
}

@Component({
  standalone: true,
  imports: [
    SharedModule,
    WavelengthUiModule
  ],
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  providers: [
    {
      provide: WavelengthShellService,
      useExisting: app_ShellService
    }
  ]
})
export class ShellComponent {

  title: string = "Footprint Portal";
  subtitle: string = "";
  logo: string = "assets/img/footprint_2024_icon_white.svg";

  account: AccountInfo;
  home: IMenubarItem;
  items: IMenubarItem[];
  menubar: any;

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    private shell: app_ShellService,
    private datasources: app_DatasourceService,
    private flows: app_FlowService,
    private reports: app_ReportService,
    private localization: app_LocalizationService,
    private operations: app_OperationService,
    private logger: CleanupLoggerService,

    private location: Location,
    private authService: MsalService,
    private route: ActivatedRoute,
    private router: Router,
    private loadingBarService: LoadingBarService,
    private titleService:Title,
    private datexErrorService: DatexErrorService,
    @Inject(MSAL_INTERCEPTOR_CONFIG) private msalInterceptorConfiguration: MsalInterceptorConfiguration
  ) {

    this.home = new MenuItemModel(
      'home',
      'ms-Icon ms-Icon--ViewDashboard',
      'Orders Dashboard',
      [],
      () => this.openHome()
    );

    this.items = [
    
      new MenuItemModel('orders', 'ms-Icon ms-Icon--ShoppingCart', 'Orders',         []
        ,      
        () => {
          this.shell.FootPrintPortalManager.openorders_hub(
          false
        )
        },
      ),
    
      new MenuItemModel('inventory', 'ms-Icon ms-Icon--Product', 'Inventory',         []
        ,      
        () => {
          this.shell.FootPrintPortalManager.openinventory_hub(
          {
            ownerId:  null ,
            projectId:  null ,
            warehouseId:  null 
          },
          false
        )
        },
      ),
    
      new MenuItemModel('invoices', 'ms-Icon ms-Icon--Invoice', 'Invoices',         []
        ,      
        () => {
          this.shell.FootPrintPortalManager.openinvoices_hub(
          {
            ownerId:  null ,
            projectId:  null 
          },
          false
        )
        },
      ),
    
      new MenuItemModel('materials', 'ms-Icon ms-Icon--GenericScan', 'Materials',         []
        ,      
        () => {
          this.shell.FootPrintPortalManager.openmaterials_hub(
          {
            ownerId:  null ,
            projectId:  null 
          },
          false
        )
        },
      ),
    
      new MenuItemModel('transactions', 'ms-Icon ms-Icon--SearchData', 'Transactions',         []
        ,      
        () => {
          this.shell.FootPrintPortalManager.openinventory_transactions_hub(
          false
        )
        },
      ),
    ];

    this.menubar = { 
        orders: this.items.find(i => i.id == 'orders') as { hidden: boolean }, 
        inventory: this.items.find(i => i.id == 'inventory') as { hidden: boolean }, 
        invoices: this.items.find(i => i.id == 'invoices') as { hidden: boolean }, 
        materials: this.items.find(i => i.id == 'materials') as { hidden: boolean }, 
        transactions: this.items.find(i => i.id == 'transactions') as { hidden: boolean }, 
    };
  }

  private addScript(type: EmbedScriptType, data: string) {
    switch(type){
      case EmbedScriptType.Inline:
        this.addInlineScript(data);
        break;
      case EmbedScriptType.External:
        this.addExternalScript(data);
        break;
      default:
        throw new Error(`Unknown script type ${type}`);
    }
  }

  private addInlineScript(body: string) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = body;
    document.body.appendChild(script);
  }

  private addExternalScript(url: string) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.defer = true;
    document.body.appendChild(script);
  }

  private openHome() {    
    this.shell.FootPrintPortalManager.openorders_dashboard_hub(
      false
    );
  }

  onLogoutClicked(): void {
    this.authService.logout();
  }

  onInitialized() {
    Promise.resolve().then(() => {
      this.on_init();
    });

    this.account = this.authService.instance.getActiveAccount();
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $workspace: ShellComponent,
  
    $shell: app_ShellService,
    $datasources: app_DatasourceService,
    $flows: app_FlowService,
    $reports: app_ReportService,
    $settings: SettingsValuesService,
    $operations: app_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: app_LocalizationService,
    $event: any
  ) {
  
  // Hide navigation items
  if (await $operations.FootPrintPortalManager.Disable_Orders_Hub.isAuthorized()){
      $workspace.menubar.orders.hidden = true;
  }
  if (await $operations.FootPrintPortalManager.Disable_Inventory_Hub.isAuthorized()){
      $workspace.menubar.inventory.hidden = true;
  }
  if (await $operations.FootPrintPortalManager.Disable_Invoices_Hub.isAuthorized()){
      $workspace.menubar.invoices.hidden = true;
  }
  if (await $operations.FootPrintPortalManager.Disable_Materials_Hub.isAuthorized()){
      $workspace.menubar.materials.hidden = true;
  }
  if (await $operations.FootPrintPortalManager.Disable_Inventory_Transactions_Hub.isAuthorized()){
      $workspace.menubar.transactions.hidden = true;
  }
  }
  //#endregion private flows
}
